// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonPlay_container__2B81H","label":"ButtonPlay_label__1M57c","button":"ButtonPlay_button__1ifUD"};